// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__H7vTn","header":"MessagesList_header__2P3qy","chat":"MessagesList_chat__3Y0DB"};